import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

// Force the section to be fully hidden — both `hidden` attribute and
// `display: none` — so no CSS rule with `display:` can reintroduce
// the empty slot before we've confirmed real cards to show.
function collapse(el) {
  if (!el) return;
  el.hidden = true;
  el.style.display = 'none';
}
function reveal(el) {
  if (!el) return;
  el.hidden = false;
  el.style.display = '';
}

async function hydrateRecentlyViewed() {
  const root = document.querySelector('[data-ash-pdp-rv]');
  if (!root || root.dataset.ashPdpRvHydrated === '1') return;

  const sectionId = root.dataset.sectionId;
  const currentId = root.dataset.currentProductId;
  const max = parseInt(root.dataset.maxItems || '6', 10);
  // NB: `Theme` is declared as `const Theme = {...}` in scripts.liquid
  // (a classical script). Top-level `const` in classical scripts binds
  // to the script scope and is visible to modules via bare identifier
  // lookup — but does NOT attach to `window`. Reading `window.Theme`
  // here was always undefined, so the guard tripped and the section
  // silently collapsed even when recently-viewed history existed.
  const themeRoutes = (typeof Theme !== 'undefined' && Theme?.routes) || window.Theme?.routes;
  const searchUrl = themeRoutes?.search_url;
  if (!sectionId || !searchUrl) {
    collapse(root);
    return;
  }

  const ids = RecentlyViewed.getProducts()
    .filter((id) => String(id) !== String(currentId))
    .slice(0, max);
  if (ids.length === 0) {
    // Fresh visitor / no history → the section stays fully collapsed.
    collapse(root);
    return;
  }

  root.dataset.ashPdpRvHydrated = '1';

  const url = new URL(searchUrl, location.origin);
  url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('type', 'product');

  try {
    await sectionRenderer.renderSection(sectionId, { cache: false, url });
    const updated = document.querySelector(`[data-ash-pdp-rv][data-section-id="${sectionId}"]`);
    const hasCards = updated?.querySelector('.ash-xs__card');
    if (hasCards) {
      reveal(updated);
    } else {
      // Search returned zero valid results (all filtered out because
      // unavailable or the current product) → keep the section gone.
      collapse(updated);
    }
  } catch (err) {
    console.warn('[ash-pdp-recently-viewed]', err);
    collapse(root);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateRecentlyViewed);
} else {
  hydrateRecentlyViewed();
}
